import { Renderer } from 'marked';

// Renderer for inline markdown
const inlineRenderer = new Renderer();
inlineRenderer.paragraph = e => e;
export default inlineRenderer;
